module.exports = __webpack_public_path__ + "img/stand length.7626f37b.png";